@if (staffMembersToDisplay() && staffMembersToDisplay().length > 0) {
  <h2 class="text-2xl font-bold mb-2">Vi jobbar här</h2>

  <div class="flex flex-col">
    @for (staffMember of staffMembersToDisplay(); track staffMember.id) {
      <app-staff-member
        [staffMember]="staffMember"
        [theme]="'sm'"
      ></app-staff-member>
    }
  </div>

  @if (showExpandButton()) {
    <app-ui-button (click)="toggleExpanded()"
                [color]="'outline-tertiary'"
                [expanded]="'block'">
      Se alla medarbetare
    </app-ui-button>
  }
}
